import React, {useState} from 'react'

export const EmailContent = (props) => {
  return (
    <div id={props.id} className="email-content"
    contentEditable
    onBlur={e=>{
      //props.setContent(e.currentTarget.textContent);
    }}
    onChange={e=>{
      //props.setContent(e.currentTarget.textContent);
    }}
    suppressContentEditableWarning={true}
    >
      <h2>Hi ###NAME###,</h2>
        <p>
            This email contains a link for you to complete Leadership Behaviour Assessment
            “Powered by Artificial Intelligence” for High Performing Leaders - an online assessment.
        </p>

        <p>It has been sent to you on behalf of Inspire One and is valid until the end of the day on ###VALIDITY-DATE### after which you will no longer be able to take the assessment.</p>

        <h3>Recommendations:</h3>
        <ol>
            <li>Try to find somewhere quiet where you can complete the assessment undisturbed.</li>
            <li>A reliable and stable internet connection is required either on broadband, WiFi, 3G or 4G. If you lose your connection, you can re-launch the assessment again when your connection returns.</li>
            <li>We recommend the use of a modern browser for example: IE11+, Chrome, Safari, iOS, Android. Older versions of browsers may not be supported or may not present the assessment correctly. A warning will be displayed before an assessment starts if your browser is out of date.</li>
        </ol>
        <p>When you are ready please click on the button below to start the assessment.</p>
    </div>
  )
}

export const DownloadContent = (props) => {
    return (
      <div id={props.id}  className="email-content"
      contentEditable
        onBlur={e=>{
          //props.setContent(e.currentTarget.textContent);
        }}
        onChange={e=>{
          //props.setContent(e.currentTarget.textContent);
        }}
        suppressContentEditableWarning={true}
        >
          <h2>Hi ###NAME###,</h2>
          <p>
              This email contains a link for you to download Leadership Behaviour Assessment report
              “Powered by Artificial Intelligence” for High Performing Leaders - an online assessment.
          </p>
  
          <p>It has been sent to you on behalf of Inspire One.</p>
  
          <p>Please click on the button below to download the assessment.</p>
      </div>
    )
  }
  
